<template>
    <layout-card
        :isCustomizable="settings.isCustomizable"
        @hide-card="$emit('hide-card', 'annotation')"
        @refresh-card="refreshTab(currentTab, {}, true)"
        class="card-annotation"
        :error="error"
        :loading="loading"
    >
        <!-- SLOTED TITLE -->
        <template #title>
            {{ name }}
        </template>

        <!-- SLOTED CONTENT -->
        <template #content v-if="cardData">
            <!-- The tab for the header -->
            <el-tabs
                @tab-click="fetchTab"
                :value="currentTab"
                class="flex-column hp-10 annotation-tab"
            >
                <el-tab-pane
                    v-for="(cardType, cardTypeIndex) in cardTypes"
                    :key="cardTypeIndex"
                    :label="cardType.label"
                    :name="cardType.id"
                    class="flex-column hp-10 pr-2"
                >
                    <!-- ICONE -->
                    <template #label>
                        <span>
                            <CompassTooltip :content="cardType.label" :arrow="false">
                                <CompassIcon :icon="cardType.icon" />
                            </CompassTooltip>
                        </span>
                    </template>

                    <!-- Input in dashboard tab for create a annotation -->
                    <div v-if="cardType.id == 'dashboard'">
                        <RichText
                            v-model="annotation.annot_text"
                            :placeholder="$t.__('dashboard.cards.AnnotationCard.write_something')"
                            :options="optionsRichText"
                            class="custom-richtext"
                        />

                        <div class="aright mt-2 mb-3">
                            <a
                                class="link"
                                :class="annotation.annot_text.length == '' ? 'hidden' : ''"
                                type="primary"
                                @click="save(annotation, currentTab)"
                                >{{ $l10n.__('Enregistrer') }}</a
                            >
                        </div>
                    </div>

                    <!-- Display annotation -->
                    <ul class="annotationCard hp-10">
                        <template v-if="cardType.data.length > 0">
                            <annotation
                                v-for="(annotation, cardDataIndex) in cardType.data"
                                :key="cardDataIndex"
                                :data="annotation"
                                @save-annotation="save"
                                :currentTab="currentTab"
                            />
                        </template>
                        <template v-else>
                            <div
                                class="my-0 mx-auto flex-column hp-10 ai-center jc-center"
                                style="width: 170px"
                            >
                                <img
                                    src="/ressources/logged/img/dashboard/dashboard-comment.svg"
                                    alt=""
                                    width="120"
                                />
                                <div class="mt-3 gray-60 acenter">
                                    {{ $l10n.__("Vous n'avez pas de commentaires") }}
                                </div>
                            </div>
                        </template>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import Annotation from './Annotation.vue';
import CardMixin from './CardMixin.js';
import AnnotationService from 'Services/Annotations/AnnotationService';
import RichText from 'vcomponents/richtext/RichText.vue';

export default {
    components: {
        LayoutCard,
        Annotation,
        RichText,
    },
    mixins: [CardMixin],
    data() {
        return {
            annotation: {
                annot_text: '',
                annot_relatedtype: 'dashboard',
            },
            currentTab: this.customSettings.current_tab,
            annotationService: new AnnotationService(),
            optionsRichText: [
                'Heading',
                'Bold',
                'Italic',
                'Underline',
                'Color',
                'Highlight',
                'BulletList',
                'OrderedList',
                'Divider',
                'Link',
                'Mention',
            ],
        };
    },

    computed: {
        cardTypes() {
            var docType = [
                'estimate',
                'invoice',
                'model',
                'delivery',
                'order',
                'creditnote',
                'proforma',
            ];
            var purDocType = [
                'purOrder',
                'purDelivery',
                'purInvoice',
                'purCreditNote',
                'purTemplate',
                'purchase',
            ];
            var thirdType = ['third', 'prospect', 'supplier'];

            var permissions = [
                {
                    id: 'dashboard',
                    label: this.$l10n.__('Tableau de bord'),
                    data: this.cardData
                        .filter((card) => card.type == 'dashboard')
                        .sort(function (a, b) {
                            return b.timestamp - a.timestamp;
                        }),
                    icon: 'nav-dashboard',
                },
            ];

            if (this.settings.perms.third) {
                permissions.push({
                    id: 'third',
                    label: this.$l10n.__('Sociétés'),
                    data: this.cardData
                        .filter((card) => thirdType.includes(card.type))
                        .sort(function (a, b) {
                            return b.timestamp - a.timestamp;
                        }),
                    icon: 'nav-company',
                });
            }

            if (this.settings.perms.people) {
                permissions.push({
                    id: 'people',
                    label: this.$l10n.__('Contacts'),
                    data: this.cardData
                        .filter((card) => card.type == 'people')
                        .sort(function (a, b) {
                            return b.timestamp - a.timestamp;
                        }),
                    icon: 'nav-contact',
                });
            }

            if (this.settings.perms.opportunity) {
                permissions.push({
                    id: 'opportunity',
                    label: this.$l10n.__('Opportunités'),
                    data: this.cardData
                        .filter((card) => card.type == 'opportunity')
                        .sort(function (a, b) {
                            return b.timestamp - a.timestamp;
                        }),
                    icon: 'nav-opportunity',
                });
            }

            if (this.settings.perms.document) {
                permissions.push({
                    id: 'document',
                    label: this.$l10n.__('Documents de ventes'),
                    data: this.cardData
                        .filter((card) => docType.includes(card.type))
                        .sort(function (a, b) {
                            return b.timestamp - a.timestamp;
                        }),
                    icon: 'nav-billing',
                });
            }

            if (this.settings.perms.purchase) {
                permissions.push({
                    id: 'purchase',
                    label: this.$l10n.__("Documents d'achats"),
                    data: this.cardData
                        .filter((card) => purDocType.includes(card.type))
                        .sort(function (a, b) {
                            return b.timestamp - a.timestamp;
                        }),
                    icon: 'nav-purchases',
                });
            }

            permissions.push({
                id: 'task',
                label: this.$l10n.__('Tâches'),
                data: this.cardData
                    .filter((card) => card.type == 'task')
                    .sort(function (a, b) {
                        return b.timestamp - a.timestamp;
                    }),
                icon: 'task',
            });

            return permissions;
        },
    },
    updated: function () {
        if (!this.currentTab) {
            this.currentTab = this.customSettings.current_tab;
        }
    },

    methods: {
        save(annot, tab) {
            this.loading = true;

            this.annotationService
                .createAnnotation(
                    annot.annot_text,
                    null,
                    null,
                    _.toInteger(annot.annot_parentid),
                    null,
                )
                .then((response) => {
                    this.fetchCard(this.type, { params: { relatedType: tab } });
                    this.loading = false;
                    annot.annot_text = '';
                })
                .catch((error) => {
                    this.errors.setErrors(error.response.data.error.message);
                    Push.error(
                        this.$l10n.__(
                            "Une erreur est survenue lors de l'enregistrement du commentaire",
                        ),
                    );
                    this.loading = false;
                });
        },

        fetchTab(tab) {
            this.currentTab = tab.name;
            this.fetchCard(this.type, { params: { current_tab: this.currentTab } });
        },

        refreshTab(tab) {
            this.fetchCard(this.type, { params: { current_tab: tab } });
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_mixins';
@import '~@sellsy/styleguide/src/_variables';

.annotation-tool-tip {
    transform: translateX(-8.5%);
}
.card-annotation {
    .card-body {
        padding-top: 0 !important;
    }
    .annotation-tab {
        .el-tabs__nav {
            padding-left: 1px;
        }
        .el-tabs__nav-prev,
        .el-tabs__nav-next {
            top: 9px;
        }
        .el-tabs__item {
            padding-top: 8px !important;
        }
        .el-tabs__content {
            height: 100%;
        }
    }
    .custom-richtext {
        min-width: fit-content;
    }
}
</style>
